import { render } from "./component-adress.vue?vue&type=template&id=32b4476c"
import script from "./component-adress.vue?vue&type=script&setup=true&lang=js"
export * from "./component-adress.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/counteragent-version-card/components/component-adress.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "32b4476c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('32b4476c', __exports__)) {
    api.reload('32b4476c', __exports__)
  }
  
  module.hot.accept("./component-adress.vue?vue&type=template&id=32b4476c", () => {
    api.rerender('32b4476c', render)
  })

}


export default __exports__